import React from 'react';
import { AntDesign } from '@expo/vector-icons';
import {  ParagraphSRegular, Subtitle2 } from '../../config/designSystem/typography';
import { TouchableOpacity, View } from 'react-native';
import { TwoButtonsHorizontal } from '../Button/TwoButtonsHorizontal';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';

interface BasicModalWithTwoButtonsProps {
    onDismiss: () => void;
    onMainAction: () => void;
    mainText: string;
    buttonDismissText: string;
    buttonMainActionText:string;
    titleText: string;
  }

export const BasicModalWithTwoButtons = ({  onDismiss, onMainAction, titleText, mainText, buttonDismissText, buttonMainActionText}: BasicModalWithTwoButtonsProps) => {
  const {width} = useAvailableDimensions();
  const WIDTH_MODAL = Math.min(0.9*width,800);

  return (
    <View style={{
      justifyContent: 'center',
      alignItems: 'center',
      flex:1
    }}>
      <View style={{
        backgroundColor:'white',
        borderRadius: 10,
        paddingTop: 20,
        width:WIDTH_MODAL,
      }}>
        <TouchableOpacity onPress={onDismiss}>
          <View style={{alignSelf:'flex-end',marginBottom:20, marginRight: 30}}>
            <AntDesign name="close" size={20} color='black' />
          </View>
        </TouchableOpacity>
        <View style={{ justifyContent: 'center', alignItems: 'center', marginBottom: 30}}>
          <Subtitle2>
            {titleText}
          </Subtitle2>
        </View>
        <View style={{ justifyContent: 'center', alignItems: 'center', marginBottom: 30, paddingHorizontal:20}}>
          <ParagraphSRegular align={true}>
            {mainText}
          </ParagraphSRegular>
        </View>
        <View style={{alignItems:'center', justifyContent:'center'}}>
          <TwoButtonsHorizontal smallText={true} width={WIDTH_MODAL} onPressLeft={onDismiss} onPressRight={onMainAction} labelLeft={buttonDismissText} labelRight={buttonMainActionText}/>
        </View>
      </View>
    </View>
  );
};